import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { POKER_SEAT_ROUNDED_RECT_RADIUS } from '../../../../constants/constants';
import { useAppSelector } from '../../../../redux/store';
import { PLAYER_ALL_BUBBLES_OUTLINE_COLOR_NUM } from '../../../../styles/colors';
import { Rect } from '../../pixiComponents/rect';
/**
 * Shows an outline around the entire seat if there are active player bubbles.
 * This serves to attract attention to the player because of something that is temporarilty happening
 * (and that is often happening while a lot of other things are going on, such as during a showdown
 * or the start of a hand) and also to create a visual separation between players, as the bubble
 * for a player seated just below another player may look as if the bubble is associated with the
 * other player above.
 */
export const PlayerAllBubblesOutlineContainer = ({ seatIndex, bounds }) => {
    const hasPlayerBubbles = useAppSelector((state) => !!state.playerBubbles.bubbles[seatIndex]?.length);
    if (!hasPlayerBubbles) {
        return null;
    }
    const { w, h } = bounds;
    return (_jsx(Container, { interactiveChildren: false, children: _jsx(Rect, { x: -w / 2, y: -h / 2, w: w, h: h, lineWidth: 2, lineColor: PLAYER_ALL_BUBBLES_OUTLINE_COLOR_NUM, radius: POKER_SEAT_ROUNDED_RECT_RADIUS }) }));
};
